import createIcon from '../../createIcon';

/**
 * @component @name ThumbUpAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiAyMUg0QzQuNTUgMjEgNSAyMC41NSA1IDIwVjExQzUgMTAuNDUgNC41NSAxMCA0IDEwSDJWMjFaTTIxLjgzIDEzLjg4QzIxLjk0IDEzLjYzIDIyIDEzLjM2IDIyIDEzLjA4VjEyQzIyIDEwLjkgMjEuMSAxMCAyMCAxMEgxNC41TDE1LjQyIDUuMzVDMTUuNDcgNS4xMyAxNS40NCA0Ljg5IDE1LjM0IDQuNjlDMTUuMTEgNC4yNCAxNC44MiAzLjgzIDE0LjQ2IDMuNDdMMTQgM0w3LjU5IDkuNDFDNy4yMSA5Ljc5IDcgMTAuMyA3IDEwLjgzVjE4LjY3QzcgMTkuOTUgOC4wNSAyMSA5LjM0IDIxSDE3LjQ1QzE4LjE1IDIxIDE4LjgxIDIwLjYzIDE5LjE3IDIwLjAzTDIxLjgzIDEzLjg4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ThumbUpAlt = createIcon('ThumbUpAlt', [
  [
    'path',
    {
      d: 'M2 21H4C4.55 21 5 20.55 5 20V11C5 10.45 4.55 10 4 10H2V21ZM21.83 13.88C21.94 13.63 22 13.36 22 13.08V12C22 10.9 21.1 10 20 10H14.5L15.42 5.35C15.47 5.13 15.44 4.89 15.34 4.69C15.11 4.24 14.82 3.83 14.46 3.47L14 3L7.59 9.41C7.21 9.79 7 10.3 7 10.83V18.67C7 19.95 8.05 21 9.34 21H17.45C18.15 21 18.81 20.63 19.17 20.03L21.83 13.88Z',
      key: '1kaqod',
    },
  ],
]);

export default ThumbUpAlt;
